import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import LogoImg from "../../assets/images/logo.png";
import conv from "../../assets/lang/i18n";

const MainHeader = (props) => {
  const navi = useNavigate();
  return (
    <div>
      <Navbar bg="costom-light" expand="lg">
        <Container>
          <Navbar.Brand
            onClick={() => {
              navi("/");
            }}
          >
            <img className="p-cursor" src={LogoImg} width="150" height="40" alt="Intro-logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="navbar_margin_left">
              <Nav.Link
                onClick={() => {
                  navi("/");
                }}
              >
                {conv.t("nav.home")} &nbsp;
              </Nav.Link>
              <Nav.Link
                onClick={() => {
                  navi("/dday");
                }}
              >
                {conv.t("nav.dday")} &nbsp;
              </Nav.Link>
              <NavDropdown
                title={conv.t("nav.language")}
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item onClick={props.paramChangeLanguage}>
                  {conv.t("nav.en")}
                </NavDropdown.Item>
                <NavDropdown.Item onClick={props.paramChangeLanguage}>
                  {conv.t("nav.ko")}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  onClick={() => {
                    navi("/contact");
                  }}
                >
                  {conv.t("nav.askToAdmin")}
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default MainHeader;
